import DeliveryDetails from './DeliveryDetails';

export default DeliveryDetails;
